import * as React from "react";
import type { SVGProps } from "react";
const SvgMaestroBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 24"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#ED0006"
      d="M20.095 12.127c0 3.812-3.055 6.903-6.824 6.903s-6.824-3.09-6.824-6.903 3.055-6.903 6.824-6.903 6.824 3.09 6.824 6.903"
    />
    <path
      fill="#0099DF"
      d="M28.947 12.127c0 3.812-3.055 6.903-6.823 6.903-3.77 0-6.824-3.09-6.824-6.903s3.055-6.903 6.824-6.903 6.823 3.09 6.823 6.903"
    />
    <path
      fill="#6C6BBD"
      fillRule="evenodd"
      d="M17.697 6.873a6.92 6.92 0 0 1 2.398 5.254 6.92 6.92 0 0 1-2.398 5.254 6.92 6.92 0 0 1-2.397-5.254 6.92 6.92 0 0 1 2.397-5.254"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMaestroBadge;
